/* RESPONSIBLE TEAM: team-phone */
import type PhoneOneTimePasscode from 'embercom/models/operator/visual-builder/step/phone-one-time-passcode';
import StepConfig, { type StepConfigParams } from '../step';

export default class PhoneOneTimePasscodeConfiguration extends StepConfig {
  declare step: PhoneOneTimePasscode;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/phone-one-time-passcode',
      ...params,
    });
  }
}
